const VERSION = "10.0.5";
export {
  VERSION
};
